import styled, { css } from 'styled-components';
/**
 * Gallery labels
 */
export const galleryLabelsContainerStyles = () => css `
	pointer-events: none;
	display: block;
	grid-area: slide;
	align-self: end;
	z-index: 2;
`;
export const GalleryLabelsContainer = styled.div `
	${galleryLabelsContainerStyles}
`;
